import {useEffect} from "react";
import {toast} from "react-toastify";

const REGULAR_ICONS = {
	small: "/X-Favicon/favicon-16x16.png",
	regular: "/X-Favicon/favicon-32x32.png",
	apple: "/X-Favicon/apple-icon.png",
};

const ALERT_ICONS = {
	small: "/X-Favicon-Alert/favicon-16x16.png",
	regular: "/X-Favicon-Alert/favicon-32x32.png",
	apple: "/X-Favicon-Alert/apple-icon.png",
};

function applyFavIcons(isAlert: boolean): void {
	const linkElement = document.querySelector<HTMLLinkElement>("link[rel=icon]");
	const smallLinkElement = document.querySelector<HTMLLinkElement>("link[rel=small-icon]");
	const appleLinkElement = document.querySelector<HTMLLinkElement>("link[rel=apple-touch-icon]");
	const icons = isAlert ? ALERT_ICONS : REGULAR_ICONS;

	if (linkElement) linkElement.href = icons.regular;
	if (smallLinkElement) smallLinkElement.href = icons.small;
	if (appleLinkElement) appleLinkElement.href = icons.apple;
}

const useFaviconHook = (tabIsActive: boolean): void => {
	useEffect(() => {
		toast.onChange((payload) => {
			if (payload.status === "added" && !tabIsActive) {
				applyFavIcons(true);
			} else if (payload.status === "removed") {
				applyFavIcons(false);
			}
		});

		if (tabIsActive) {
			setTimeout(() => {
				applyFavIcons(false);
			}, 800);
		} else {
			const isToastDisplayed =
				document?.getElementById("toast-container")?.hasChildNodes() || false;

			if (isToastDisplayed) {
				applyFavIcons(true);
			}
		}
	}, [tabIsActive]);
};

export default useFaviconHook;
